/**
 * Search pagination controller.
 * 
 * @since 1.0.0
 * @package dealerkit-wp
 */
export class PaginationController
{
    constructor(core, window) {
        this.core = core

        this.window = window

        this.core.container.make('search.service').then(search => {
            this.search = search

            this.listenForSearchNavigationEvents();
        })
    }

    listenForSearchNavigationEvents() {
        // Next Page
        this.core.events.on('search.pagination.next', () => {
            this.search.nextPage()

            this.window.scrollTo({
                top: 0
            })
        })

        // Previous Page
        this.core.events.on('search.pagination.previous', () => {
            this.search.previousPage()

            this.window.scrollTo({
                top: 0
            })
        })

        // Goto Page
        this.core.events.on('search.pagination.go', (e) => {
            this.search.gotoPage(e.detail)

            this.window.scrollTo({
                top: 0
            })
        })
    }

    render(containerEl) {
        if (this.search.totalResults() === 0) {
            containerEl.style.display = 'none';
        } else {
            containerEl.style.display = '';
        }

        let i = 1;
        let sibling = containerEl.querySelector('.search-pagination-previous')

        this.clearPagesFromPagination(containerEl)

        if (this.search.totalPages() > 5) {
            this.createSummaryButtons(sibling)
        } else {
            this.createButtonsForAllPages(sibling)
        }

        this.highlightCurrentPage(containerEl)
    }

    clearPagesFromPagination(containerEl) {
        containerEl.querySelectorAll('.search-pagination-button').forEach(el => {
            el.parentNode.remove()
        })

        containerEl.querySelectorAll('.search-pagination-spacer').forEach(el => {
            el.remove()
        })
    }

    highlightCurrentPage(containerEl) {
        containerEl.querySelectorAll('li').forEach(el => {
            el.classList.remove('search-pagination-current')
        })

        containerEl.querySelector('li button[dk-page="' + this.search.currentPage() + '"]')
            .parentNode.classList.add('search-pagination-current')
    }

    createButtonForPage(number, afterEl) {
        const li = this.window.document.createElement('li')

        const button = this.window.document.createElement('button')
        button.innerText = number
        button.setAttribute('dk-page', number)
        button.classList.add('search-pagination-button')
        li.append(button)

        afterEl.after(li)

        button.addEventListener('click', (e) => {
            this.search.gotoPage(e.target.getAttribute('dk-page'))

            window.scrollTo({
                top: 0
            })
        })

        return li
    }

    createButtonSpacer(afterEl) {
        const li = this.window.document.createElement('li')

        li.innerText = '...'
        li.classList.add('search-pagination-spacer')

        afterEl.after(li)

        return li
    }

    createButtonsForAllPages(sibling) {
        let i = 1;
        while (this.search.totalPages() >= i) {
            sibling = this.createButtonForPage(i, sibling)
            i++
        }
    }

    createButtonsUsingDescription(description, sibling) {
        description.forEach(def => {
            if (def.page === 'spacer') {
                sibling = this.createButtonSpacer(sibling)
            } else {
                sibling = this.createButtonForPage(def.page, sibling)
            }
        })
    }

    createSummaryButtons(sibling) {
        const thirdFromLastPage = (
            (this.search.totalPages() - this.search.currentPage()) <= 3
        )

        if (this.search.currentPage() < 5) {
            this.createLeadingSegmentSummaryButtons(sibling)
        } else if (this.search.currentPage() >= 4 && !thirdFromLastPage) {
            this.createCenterSegmentSummaryButtons(sibling)
        } else if (thirdFromLastPage) {
            this.createTrailingSegmentSummaryButtons(sibling)
        }
    }

    createLeadingSegmentSummaryButtons(sibling) {
        this.createButtonsUsingDescription([
            { page: 1 }, 
            { page: 2 }, 
            { page: 3 }, 
            { page: 4 }, 
            { page: 5 }, 
            { page: 'spacer' }, 
            { page: this.search.totalPages() }
        ], sibling)
    }

    createCenterSegmentSummaryButtons(sibling) {
        this.createButtonsUsingDescription([
            { page: 1 }, 
            { page: 'spacer' }, 
            { page: this.search.currentPage() - 2 }, 
            { page: this.search.currentPage() - 1 }, 
            { page: this.search.currentPage() }, 
            { page: this.search.currentPage() + 1 }, 
            { page: this.search.currentPage() + 2 }, 
            { page: 'spacer' }, 
            { page: this.search.totalPages() }
        ], sibling)
    }

    createTrailingSegmentSummaryButtons(sibling)
    {
        this.createButtonsUsingDescription([
            { page: 1 }, 
            { page: 'spacer' }, 
            { page: this.search.totalPages() - 4 }, 
            { page: this.search.totalPages() - 3 },
            { page: this.search.totalPages() - 2 }, 
            { page: this.search.totalPages() - 1 }, 
            { page: this.search.totalPages() }
        ], sibling)
    }
}